import isNil from 'lodash/isNil';
import {
  Article, DonationArticle, ShippingCostsArticle, Timeslot,
} from '../../generated/graphql';
import { IQuantities } from '../../context/interfaces/IOrder';

export { getCloudinaryUrl } from './getCloudinaryUrl';

export const isValidObjectId = (str?: string | null) : boolean => (str ? /^[a-f\d]{24}$/i.test(str) : false);

export const isDeliverMethod = (method?: string | null): boolean => method === 'deliver';

export const isDevelopment = process.env.NODE_ENV === 'development';

export const isEmailValid = (email: string): boolean => {
  const regEx = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/;

  return regEx.test(email);
};

export const isSameDay = (first: Date, second: Date) : boolean => first.getFullYear() === second.getFullYear()
      && first.getMonth() === second.getMonth()
      && first.getDate() === second.getDate();

export const formatTimeslot = (ts : Timeslot, locale: string) : string => {
  if (ts.start === null || ts.end === null || ts.start === undefined || ts.end === undefined) return '';

  const start = new Date(ts.start);
  const end = new Date(ts.end);

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  return `${start.toLocaleDateString(locale, options)} - ${isSameDay(start, end) ? end.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  }) : end.toLocaleDateString(locale, options)}`;
};

export const SHORT_DATE_TIME : Intl.DateTimeFormatOptions = {
  day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
};

export const isDefined = <T>(value: T | null | undefined): value is T => !isNil(value);

export const isRegularArticle = (a: Article | DonationArticle | ShippingCostsArticle): a is Article => a.__typename === 'Article';

export const omitArticleIds = (quantities: IQuantities, articleIds: Array<string | undefined>) : IQuantities => Object
  .entries(quantities)
  .reduce((obj, [articleId, quantity]) => (articleIds.includes(articleId) ? obj : {
    ...obj,
    [articleId]: quantity,
  }), {});
